var jade = require("/home/romain/Cozy/cozy-proxy/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<section class=\"popup\"><header><a href=\"http://cozy.io\" target=\"_blank\" title=\"Cozy Website\"></a></header><div class=\"container\"></div></section>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./app/views/templates/layout_app.jade
 ** module id = 69
 ** module chunks = 1
 **/